module.exports = __webpack_public_path__ + "img/vertical_6_5_9006.f464c6e2.png";